import React from 'react'
import PropTypes from 'prop-types'
import {
  GifContainer,
  AnimatedChecLoading,
} from './LoadingSwitchMeter.style.js'

const LoadingSwitchMeter = ({ style, width, height }) => (
  <GifContainer>
    <AnimatedChecLoading style={style} height={height} width={width} />
  </GifContainer>
)

LoadingSwitchMeter.defaultProps = {
  style: {},
  width: 48,
  height: 100,
}

LoadingSwitchMeter.propTypes = {
  style: PropTypes.object,
  width: PropTypes.number,
  height: PropTypes.number,
}

export default LoadingSwitchMeter
